import React from 'react';
import { bonuses, bonusesTotal } from '../data/content';
import { formatArs } from '../utils/format';
export function Bonuses() {
  return <section id="bonus" className="w-full bg-white" data-id="element-29" data-mp="pjg7a5ljxg31">
      <div className="mx-auto max-w-content px-5 py-16 lg:px-8 lg:py-24" data-id="element-30" data-mp="avlbuhg5sxm9">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between" data-id="element-31" data-mp="at8ti36hol8o">
          <div className="max-w-2xl" data-id="element-32" data-mp="fs3ffdzr6px0">
            <p className="font-display text-sm font-bold text-gold-deep" data-id="element-33" data-mp="1tvi34yt1mlb">
              Incluido sin costo extra
            </p>
            <h2 className="mt-3 font-display text-3xl font-black leading-tight text-ink sm:text-4xl" data-id="element-34" data-mp="5wrzwtgiteo7">
              6 bonus para aplicarlo desde el primer mes
            </h2>
          </div>
          <p className="text-sm text-ink-muted md:text-right" data-id="element-35" data-mp="3t1hj0pu53ayh">
            Valor de los bonus
            <br data-id="element-36" data-mp="1mb9zzc55g2on" />
            <span className="font-display text-xl font-extrabold text-ink line-through" data-id="element-37" data-mp="1marstkgy841y">
              {formatArs(bonusesTotal)}
            </span>{' '}
            <span className="font-display text-xl font-extrabold text-forest" data-id="element-38" data-mp="3idwpln4yzimt">
              incluidos
            </span>
          </p>
        </div>

        <ul className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-39" data-mp="3df3ajqa1bjkj">
          {bonuses.map(bonus => <li key={bonus.number} className="flex h-full flex-col rounded-xl border border-line bg-cream p-6" data-id="element-40" data-mp="3r68h7cbtlc4d">
              <div className="flex items-center justify-between" data-id="element-41" data-mp="3n79dfv1trlei">
                <span className="font-display text-xs font-bold uppercase tracking-wide text-ink-muted" data-id="element-42" data-mp="2zglu8dmgl9cn">
                  Bonus {bonus.number.toString().padStart(2, '0')}
                </span>
                <span className="rounded bg-forest px-2 py-1 text-[11px] font-bold uppercase tracking-wide text-cream" data-id="element-43" data-mp="38hbi8v5h9vft">
                  Gratis
                </span>
              </div>
              <h3 className="mt-4 font-display text-lg font-extrabold leading-snug text-ink" data-id="element-44" data-mp="np8dsosv5pmy">
                {bonus.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-ink-muted" data-id="element-45" data-mp="iqoruoe9sdul">
                {bonus.description}
              </p>
              <p className="mt-auto pt-5 text-sm text-ink-muted" data-id="element-46" data-mp="3hhzjrant5xa8">
                Valor individual{' '}
                <span className="line-through" data-id="element-47" data-mp="3ljul2f5qoao0">{formatArs(bonus.value)}</span>
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}